import dayjs from "dayjs";

import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";

import Link from "../../../../atoms/mui/Link";

const ReceivedReportsTab = ({ sharedReports = [] }) => {
  const sorted = [...sharedReports].sort((a, b) => b.year - a.year);

  if (sorted.length === 0) {
    return (
      <Box p={3}>
        <Typography variant="body2" color="textSecondary">
          No reports have been shared by this vendor yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Year</TableCell>
          <TableCell>Shared Date</TableCell>
          <TableCell>Status</TableCell>
          <TableCell align="right">Report</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sorted.map(({ year, sharedAt, isFinalized, reportUrl }) => {
          const sharedDate = sharedAt?.toDate
            ? sharedAt.toDate()
            : sharedAt
              ? new Date(sharedAt)
              : null;

          return (
            <TableRow key={year}>
              <TableCell>
                <Typography variant="body2">{year}</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body2" color="textSecondary">
                  {sharedDate ? dayjs(sharedDate).format("MMM D, YYYY") : "—"}
                </Typography>
              </TableCell>
              <TableCell>
                {isFinalized ? (
                  <Chip label="Finalized" color="success" size="small" />
                ) : (
                  <Chip label="Preliminary" color="warning" size="small" />
                )}
              </TableCell>
              <TableCell align="right">
                {reportUrl ? (
                  <Link href={reportUrl}>View</Link>
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    —
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default ReceivedReportsTab;
